'use strict';
const _ = require('underscore');
module.exports = function GoldAtlasApi(authenticationModel, goldApi) {
	const self = this,
		licenseAction = function (params, apiAction, resolveFalseIfNoLicense) {
			return Promise.resolve().then(authenticationModel.getLicense).then(function (license) {
				if (!license || _.isEmpty(license)) {
					if (resolveFalseIfNoLicense) {
						return false;
					}
					throw 'not-authenticated';
				}
				return goldApi.exec(apiAction, _.extend({}, params, {license: license}));
			});
		};
	self.exists = function (slug) {
		if (!slug) {
			return Promise.reject('invalid-args');
		}
		return licenseAction({slug: slug}, 'atlas/exists', true);
	};
	self.delete = function (slug) {
		if (!slug) {
			return Promise.reject('invalid-args');
		}
		return licenseAction({slug: slug}, 'atlas/delete');
	};
};
